interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: React.ReactNode;
  children: React.ReactNode;
  onConfirm?: () => void;
  onCancel?: () => void;
  showFooter?: boolean;
  btnMsg?: string;
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  onConfirm,
  onCancel,
  showFooter = true,
  btnMsg,
}) => {
  if (!isOpen) return null; // 未开启时不渲染

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
      {/* 弹窗容器 */}
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 overflow-hidden">
        {/* 弹窗头部 */}
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 focus:outline-none"
          >
            <i className="fas fa-times text-xl"></i>
          </button>
        </div>

        {/* 弹窗内容 */}
        <div className="p-4">{children}</div>

        {/* 弹窗底部（可选） */}
        {showFooter && (
          <div className="flex justify-center space-x-2 p-4 border-t border-gray-200">
            <button
              onClick={onConfirm}
              className="px-4 py-2 bg-gradient-to-br from-[#3b82f6] to-[#2563eb] text-white rounded hover:bg-blue-600 focus:outline-none  w-30"
            >
              {btnMsg || "去微信"}
            </button>
            <button
              onClick={onCancel || onClose}
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 focus:outline-none w-30"
            >
              关闭
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
